// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__15Eex","content":"RecentSearches_content__3qAAs"};